// whatsNew — 「新機能の紹介」の 1 件分の型と、未読判定 (純粋ロジック)。
//
// お知らせ (system.announce.*) とは別枠。中身は web のコードに同梱し、その機能の
// リリースと一緒に配る (docs/_wip/whats-new-2026-10-15.md)。

export interface WhatsNewEntry {
  /** 安定 ID (既読管理のキー)。例 `2026-10-layer-thumbnail`。一度出したら変えない。 */
  readonly id: string;
  /** 表示用の日付 (例 `2026年10月`)。 */
  readonly date: string;
  /** 並び順用の ISO 月日 (例 `2026-10`)。新しい順に並べる。 */
  readonly sortKey: string;
  readonly title: string;
  readonly body: string;
  /** 動画 URL (任意)。 */
  readonly videoUrl?: string;
  /** 動画の静止画 (poster、任意)。 */
  readonly posterUrl?: string;
}

/** 新しい順 (sortKey 降順、同値は配列の先にあるものを新しいとみなす)。入力は変更しない。 */
export const sortWhatsNewNewestFirst = (
  entries: ReadonlyArray<WhatsNewEntry>,
): ReadonlyArray<WhatsNewEntry> =>
  entries
    .map((entry, index) => ({ entry, index }))
    .sort((a, b) =>
      a.entry.sortKey === b.entry.sortKey
        ? a.index - b.index
        : a.entry.sortKey < b.entry.sortKey
          ? 1
          : -1,
    )
    .map((x) => x.entry);

/** まだ見ていない紹介。 */
export const unreadWhatsNew = (
  entries: ReadonlyArray<WhatsNewEntry>,
  seenIds: ReadonlySet<string>,
): ReadonlyArray<WhatsNewEntry> => entries.filter((e) => !seenIds.has(e.id));

export const hasUnreadWhatsNew = (
  entries: ReadonlyArray<WhatsNewEntry>,
  seenIds: ReadonlySet<string>,
): boolean => entries.some((e) => !seenIds.has(e.id));
